import { NgModule } from '@angular/core';
import { LoginComponent } from './login.component';
import { LoginMarketComponent } from './login-market/login-market.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/modules/shared/shared.module';
// SharedModule usa Highcharts pero no reexporta su módulo, así que el panel del
// login lo importa directo. No es dependencia nueva: ya está en el proyecto.
import { HighchartsChartModule } from 'highcharts-angular';

@NgModule({
    declarations: [
        LoginComponent,
        LoginMarketComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        HighchartsChartModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule
    ],
    exports: [
        FormsModule,
        ReactiveFormsModule
    ],
    providers: []
})
export class LoginModule {
}
